import { chProgressNoteFragment$data } from "@/modules/patients/services/ch/__generated__/chProgressNoteFragment.graphql"

type FollowUpAppointment = NonNullable<chProgressNoteFragment$data["followUpAppointment"]>

export const getUploadSessionCode = (
  fileUploadRequest: FollowUpAppointment["fileUploadRequest"] | undefined,
  medgateConnectOrder: FollowUpAppointment["medgateConnectOrder"] | undefined,
): string | null => {
  if (fileUploadRequest && fileUploadRequest.status !== "CANCELED") return fileUploadRequest.sessionCode
  if (medgateConnectOrder && medgateConnectOrder.status !== "CLOSED") return medgateConnectOrder.orderCode
  return null
}
